module.exports = __webpack_public_path__ + "0c675a9401d4b3782e34d4a749943e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/drop-selection-icon.png
// module id = 24
// module chunks = 0